import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from 'src/app/includes/login/login.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { CompanyService } from 'src/app/services/Modules/company.service';
import { CompanyLogoAndMongogramService } from 'src/app/services/company-logo-and-mongogram.service';
import { DashboardService } from 'src/app/includes/dashboard/dashboard.service';

@Component({
  selector: 'app-company-user-create-password',
  templateUrl: './company-user-create-password.component.html',
  styleUrls: ['./company-user-create-password.component.css'],
})
export class CompanyUserCreatePasswordComponent implements OnInit {

  verifyCodeView = false;
  code: string = '';
  first_name: string = '';
  last_name: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  hide = true;
  showScreen: boolean = false;
  params: {
    user_id: string;
    verification_code: string;
    email: string;
    phone: string
  } = {
      user_id: null,
      verification_code: null,
      email: null,
      phone: null
    };
  error: string;
  phoneCleaned = '';
  selectedCountry: any;
  loaderId = 'user-create-password';

  passwordStrength: Number = 0;
  companyCode: any;
  defaultImg: string;
  companylogoPathSubscription: any;
  companylogoPath: any;
  companylogoPathAfterLogin: any;
  policyUpperCase: boolean = false;
  policyLowerCase: boolean = false;
  policyNumber: boolean = false;
  policySpecialCharacter: boolean = false;
  policyLength: boolean = false;
  enableConfirmPassword: boolean = false;
  enableSaveButton: boolean = false;
  verifyExpiry: boolean = false;
  user: any;
  display: any;
  public timerInterval: any;
  hideVerify = true;
  disableButton: boolean = false;
  selectedCompany: any;
  Country = ['US / CA(+1)', 'Philippines(+63)', 'Pak(+92)'];
  maxMobileLength = 12;
  userMobile: any;

  public constructor(
    private router: Router,
    public loginService: LoginService,
    private _toastr: ToastrService,
    private _router: Router,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,
    private companyLogoAndMonogramService: CompanyLogoAndMongogramService,
    private dashboardService: DashboardService
  ) { }

  async ngOnInit() {
    this.companyCode = this.route.snapshot.queryParamMap.get('companyCode');
    if (this.companyCode) {
      await this.getCompanyLogo();
    }
    if (!this.companyCode) {
      this.defaultImg = "../../../assets/img/DNlogo-new.png";
    }

    // if (createdDate) {
    //   if (diff_in_days >= 1) {
    //     this.showScreen = true;
    //     this.verifyExpiry = true;
    //   }
    //   else {
    //     await this.loadData()
    //   }
    // }

    // else {
    await this.loadData()
    // }


  }

  async loadData() {
    console.log('this.route.snapshot.queryParamMap', this.route.snapshot.queryParamMap);
    this.params.user_id = this.route.snapshot.queryParamMap.get('user_id');
    this.params.email = this.route.snapshot.queryParamMap.get('email');
    this.params.verification_code = this.route.snapshot.queryParamMap.get('verification_code');
    this.params.phone = this.route.snapshot.queryParamMap.get('phone');
    await this.getUser();
  }
  async getUser() {
    const userDetail: any = await this.dashboardService.isUserVerified(this.params.user_id).toPromise();
    if (userDetail.status == 200) {
      if (userDetail.data.array == 'true') {
        this._router.navigate(['/login']);
      } else {
        this.user = userDetail.user;
        let createdDate: any;
        if(this.user.registraionSteps.linkSendDate){
          createdDate = new Date(this.user.registraionSteps.linkSendDate);
        }
        let currentDate: any;
        let diff_in_days: any;
        if(createdDate){
          currentDate = new Date();
          let diff = currentDate.getTime() - createdDate.getTime();
          diff_in_days = Math.floor(diff / (1000 * 3600 * 24));
        }
        this.showScreen = true;
        if (diff_in_days >= 1 && createdDate) {
          this.verifyExpiry = true;
        }
        else {
          if(!this.user.cognito || !this.user.registraionSteps.passwordCreated){
            this.showScreen = true;
            this.verifyExpiry = false;
            this.verifyCodeView = false;
            return;
          }
          else if (this.user.registraionSteps.passwordCreated && !this.user.registraionSteps.twoFacAuth) {
            this.verifyCodeView = true;
            this.resendConfirmationCode();
          }

        }

      }
    }
  }

  async getCompanyLogo() {
    this.loginService.getCompanyLogo(this.companyCode, null).subscribe((res: any) => {
      if (res.status = 200) {
        if (res.data[0].monogram_aws_path) {
          this.companylogoPath = res.data[0].monogram_aws_path;
          this.companyLogoAndMonogramService.setCompanyMonoGram(this.companylogoPath);
        }
        if (res.data[0].logo_aws_path) {
          this.companylogoPathAfterLogin = res.data[0].logo_aws_path;
          this.companyLogoAndMonogramService.setCompanyLogo(this.companylogoPathAfterLogin);
        }
        if (!res.data[0].monogram_aws_path) {
          console.log('../../../assets/img/DNlogo-new.png');
          this.defaultImg = "../../../assets/img/DNlogo-new.png";
        }
      } else {
        this.defaultImg = "../../../assets/img/DNlogo-new.png";
      }
    });
  }

  async onSubmit(form: NgForm) {

    if (!form.valid || !form.touched) return;

    if (this.newPassword !== this.confirmPassword) {
      this.error = 'Confirm password does not match';
      return;
    } else if (this.passwordStrength < 3) {
      form.controls['password'].setErrors({ 'incorrect': true })
      return;
    } else {
      this.error = '';
    }

    this.loader.startLoader(this.loaderId);

    try {
      const encrypted: any = await this.loginService
        .getEncryptPassword(form.value.newPassword)
        .toPromise();
      // encrypted.encreptedPass
      const data = {
        user_id: this.params.user_id,
        email: this.params.email,
        verification_code: this.params.verification_code,
        password: encrypted.encreptedPass,
      };
      const response: any = await this.companyService
        .userCreatePassword(data)
        .toPromise();
      if (response.status === 200) {
        this._toastr.success('Your password has been created. Now Sign In.', 'Success');
        this._router.navigate(['/login']);
      } else {
        this._toastr.error(response.message, 'Success');
      }

      this.loader.stopLoader(this.loaderId);
    } catch (error) {
      console.error(error);
      this._toastr.clear();
    }
  }
  clearErrors() {
    this.error = '';
  }
  checkPassword(myString) {
    let minLength = true;
    var specials = /[^A-Za-z 0-9]/g;
    let hasSpecial = specials.test(myString);
    let hasNumber = /\d/.test(myString);
    let hasUpper = /[A-Z]/.test(myString);
    let hasLower = /[a-z]/.test(myString);
    let passwordLength = myString.length;
    if (passwordLength < 10) {
      minLength = false;
    }
    const valid = hasNumber && hasUpper && hasLower && hasSpecial && minLength;
    if (!valid) {
      this.error = '\n';
      if (!hasUpper) {
        this.error += 'Password should have atleast one Uppercase Letter\n';
        this.policyUpperCase = false;
      } else if (hasUpper) {
        this.policyUpperCase = true;
      }
      if (!hasLower) {
        this.error += 'Password should have atleast one Lowercase Letter\n';
        this.policyLowerCase = false;
      } else if (hasLower) {
        this.policyLowerCase = true;
      }
      if (!hasNumber) {
        this.error += 'Password should have atleast one number\n';
        this.policyNumber = false;
      } else if (hasNumber) {
        this.policyNumber = true;
      }
      if (!hasSpecial) {
        this.error += 'Password should have atleast one Special character\n';
        this.policySpecialCharacter = false
      } else if (hasSpecial) {
        this.policySpecialCharacter = true
      }
      if (!minLength) {
        this.error += 'Password Lenght should be greater than 10\n';
        this.policyLength = false;
      } else if (minLength) {
        this.policyLength = true;
      }
      this.enableConfirmPassword = false;
      this.enableSaveButton = false;
      return false;
    }
    this.policyUpperCase = true;
    this.policyLowerCase = true;
    this.policyNumber = true;
    this.policySpecialCharacter = true
    this.policyLength = true;
    this.enableConfirmPassword = true
    return true;
  }


  async onSubmitWithCognito(form: NgForm) {
    // if (!form.valid || !form.touched) return;
    let check = this.checkPassword(this.newPassword);
    if (check) {
      if (this.newPassword !== this.confirmPassword) {
        this.error = '\nConfirm password does not match';
        return;
      } else {
        this.error = '';
        this.loader.startLoader(this.loaderId);
        try {
          // const encrypted: any = await this.loginService
          //   .getEncryptPassword(form.value.newPassword)
          //   .toPromise();
          // encrypted.encreptedPass
          const data = {
            user_id: this.params.user_id,
            email: this.params.email,
            verification_code: this.params.verification_code,
            password: form.value.newPassword,
          };
          if(this.params.phone == 'true') {
            if (this.selectedCountry === 'Pak(+92)') {
              this.phoneCleaned = '+92' + this.phoneCleaned;
            }
            else if (this.selectedCountry === 'US / CA(+1)') {
              this.phoneCleaned = '+1' + this.phoneCleaned;
            }
            else if (this.selectedCountry === 'Philippines(+63)') {
              this.phoneCleaned = '+63' + this.phoneCleaned;
            }
            data['phone'] = this.phoneCleaned
          }
          const response: any = await this.companyService
            .userCreatePassword(data)
            .toPromise();
          if (response.status === 200) {
            this.verifyCodeView = true;
            this.user.registraionSteps.twoFacExpire = response.expireDate;
            this.timer(2);
            // this._toastr.success('Your password has been created. Now Sign In.', 'Success');
            // this._router.navigate(['/login']);
          } else {
            this._toastr.error(response.message, 'Success');
          }
          this.loader.stopLoader(this.loaderId);
        } catch (error) {
          console.error(error);
          this._toastr.clear();
        }
      }
    }
  }
  async verifyCode(form: NgForm) {

    if (!form.valid || !form.touched) return;
    if (this.display =='00:00') {
      this._toastr.error('Verification Code Expire, Please Click on Resend', 'Error');
      return;
    }

    if (!this.code) {
      this.error = 'Please enter verification code';
      return;
    } else {
      this.error = '';
    }

    this.loader.startLoader(this.loaderId);

    try {
      const userData = {
        user_id: this.params.user_id,
        email: this.params.email,
        code: form.value.code
      };
      const passwordResponse: any = await this.companyService
        .verifyCode(userData)
        .toPromise();
      if (passwordResponse.status === 200) {
        this.verifyCodeView = true;
        this._toastr.success('Verification Successful, please login again', 'Success');
        if (this.companyCode) {
          const code = this.companyCode;
          this._router.navigate([`/login/${code}`]);
        } else {
          this._router.navigate(['/login']);
        }

      }
      else {
        this._toastr.error(passwordResponse.message, 'Success');
      }

      this.loader.stopLoader(this.loaderId);
    } catch (error) {
      console.error(error);
      this._toastr.clear();
    }
  }

  async resendConfirmationCode() {
    this.disableButton = true;
    const data = {
      user_id: this.params.user_id,
      email: this.params.email,
    };
    const response: any = await this.companyService
      .resendConfirmationCode(data)
      .toPromise();
    if (response.status === 200) {
      this.verifyCodeView = true;
      this.timer(2);
      this.user.registraionSteps.twoFacExpire = response.expireDate;
      this._toastr.success('Verification code has been sent', 'Success');
    } else {
      this._toastr.error(response.message, 'Success');
      // this.timer(2);
    }
  }
  isPasswordValid() {
    this.checkPassword(this.newPassword);
    if (this.newPassword != '') {
      if (this.newPassword != this.confirmPassword) {
        this.enableSaveButton = false;
      } else {
        if(this.params.phone == 'true') {
          if(this.selectedCountry && this.userMobile.length >= 12 && this.newPassword == this.confirmPassword) {
            this.enableSaveButton = true;
          }
          else {
            this.enableSaveButton = false;
          }
        }
        else {
          this.enableSaveButton = true;
        }
      }
    }
  }
  strengthChange(passwordStrength) {
    this.passwordStrength = passwordStrength;
  }

  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = '0';
    let statSec: number = 60;

    const prefix = minute < 10 ? '0' : '';

    this.timerInterval = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if(this.display.includes('-')){
        this.display = '00:00';
        clearInterval(this.timerInterval);
      }
      if (seconds <= 0) {
        if(this.display !== '00:00'){
          this.display = '00:00';
        }
        // console.log('finished');
        clearInterval(this.timerInterval);
        
      }
      this.disableButton = false;
    }, 1000);
  }

  countryFilter(Country) {
    this.phoneCleaned = "";
    this.userMobile = "";
    if (Country == 'US / CA(+1)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 12;
        // this.model.userMobile = ' +1';
        // (<HTMLInputElement>document.getElementById("userMobile")).disabled = false;
    }
    else if (Country === 'Philippines(+63)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 10;
    }
    else if (Country === 'Pak(+92)') {
        this.selectedCountry = Country;
        this.maxMobileLength = 12;
        // this.model.mobile = '+92';
        // (<HTMLInputElement>document.getElementById("mobile")).disabled = false;
    }
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    // Only Numbers 0-9
    if ((charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
    }
    else {
        return true;
    }
  }
  handlePhoneModelChange(value) {
    if (this.selectedCountry === 'Philippines(+63)') {
        this.userMobile = value;
        this.phoneCleaned = value;
    }
    else if (value) {
        const cleaned = value.replace(/-/g, '')
        // const cleaned = ('' + value).replace(/\D/g, '');
        // if (cleaned.length <= 10) {
        this.userMobile = cleaned.match(/.{1,3}/g).join('-');
        if (this.userMobile.length > 12) {
            let position = this.userMobile.lastIndexOf('-');
            this.userMobile = this.userMobile.substring(0, position) + this.userMobile.substring(position + 1);
        }
        // const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        // if (match) {
        //     this.mobile = '(' + match[1] + ') ' + match[2] + '-' + match[3];
        // }
        // else{
        //     this.model.mobile = null;
        // }
        // }
        this.phoneCleaned = cleaned.trim();
        //console.log('phoneCleaned', this.phoneCleaned)
        //console.log('Mobile model', this.model.mobile)
    }
    if(this.params.phone == 'true') {
      if(this.selectedCountry && this.userMobile.length == 12 && this.newPassword == this.confirmPassword) {
        this.enableSaveButton = true;
      }
      else {
        this.enableSaveButton = false;
      }
    }
    else {
      this.enableSaveButton = false;
    }
}
onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedData = clipboardData.getData('Text').toString();
    let number: any = pastedData.match(/\d/g);
    number = number.join("");
    if (number.length > 10) {
        number = number.substring(0, 10);
    }
    this.handlePhoneModelChange(number);
    // if (!isNaN(parseInt(clipboardData.getData('text'))) && clipboardData.getData('text').length) {
    //     let pastedText = clipboardData.getData('text');
    //     const cleaned = pastedText.replace(/-/g, '')
    //     console.log('cleaned', cleaned);
    //     if (this.selectedCountry === 'Pak(+92)') {
    //         if (this.model.mobile.includes('+92')) {
    //             this.model.mobile += "-" + cleaned.match(/.{1,3}/g).join('-');
    //             this.phoneCleaned = cleaned.trim();
    //             this.phoneCleaned = "+92" + this.phoneCleaned;
    //         } else {
    //             this.model.mobile = cleaned.match(/.{1,3}/g).join('-');
    //             this.phoneCleaned = cleaned.trim();
    //         }
    //     } else {
    //         if (this.model.mobile.includes('+1')) {
    //             this.model.mobile += "-" + cleaned.match(/.{1,4}/g).join('-');
    //             this.phoneCleaned = cleaned.trim();
    //             this.phoneCleaned = "+1" + this.phoneCleaned;
    //         } else {
    //             this.model.mobile += " " + cleaned.match(/.{1,3}/g).join('-');
    //             this.phoneCleaned = cleaned.trim();
    //         }
    //     }
    // }
}
}
